"use client";

import styles from "./TaxonomyCategoryFilter.module.css";

export default function TaxonomyCategoryFilter({
  options = [],
  selectedId = "",
  onSelect,
  allLabel = "Бүгд",
  ariaLabel = "Ангилал",
}) {
  const hasOptions = options.length > 0;

  return (
    <div className={styles.wrap} role="tablist" aria-label={ariaLabel}>
      <button
        type="button"
        role="tab"
        aria-selected={!selectedId}
        className={`${styles.chip} ${!selectedId ? styles.chipActive : ""}`}
        onClick={() => onSelect("")}
      >
        {allLabel}
      </button>
      {hasOptions
        ? options.map((opt) => {
            const id = String(opt._id ?? "");
            const label = opt.name || opt.title || opt.slug || "—";
            const depth = Number(opt.depth) || 0;
            const active = selectedId === id;
            return (
              <button
                key={id}
                type="button"
                role="tab"
                aria-selected={active}
                className={`${styles.chip} ${active ? styles.chipActive : ""}`}
                style={{ paddingLeft: `${10 + depth * 12}px` }}
                onClick={() => onSelect(id)}
              >
                {label}
              </button>
            );
          })
        : null}
    </div>
  );
}
